export default "__VITE_ASSET__FNIqb$5Z__"